import qsa from '../../scripts/util/DOM/qsa';
import addClass from '../../scripts/util/DOM/addClass';
import isElement from '../../scripts/util/isElement';

const coordinate = {
	by: {
		lat: 53.910515,
		lng: 27.505615
	},
	// ru: {
	// 	lat: 55.759417,
	// 	lng: 37.66473840000003
	// },
	ru: {
		lat: 54.771293,
		lng: 32.052950
	},
	en: {
		lat: 26.08591,
		lng: -80.37427
	}
};

const zoomControlDiv = qsa('.contacts__zoom-controls')[0];
const zoomOut = qsa('.contacts__zoom-out')[0];
const zoomIn = qsa('.contacts__zoom-in')[0];

const src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCfcwpGHhqoHyfHubmrc615IdpJ3mHIxac&signed_in=true&callback=initMap';

const classes = {
	active: 'contacts__zoom-controls_active'
};

const bindEvents = map => {
	google.maps.event.addDomListener(zoomIn, 'click', () => { // eslint-disable-line
		map.setZoom(map.getZoom() + 1);
	});

	google.maps.event.addDomListener(zoomOut, 'click', () => { // eslint-disable-line
		map.setZoom(map.getZoom() - 1);
	});

	addClass(classes.active)(zoomControlDiv);

	zoomControlDiv.index = 1;
	map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv); // eslint-disable-line
};

const init = () => {
	let coordinates = coordinate.by;

	const stylez = [
		{
			featureType: 'all',
			elementType: 'all',
			stylers: [
				{saturation: -200}
			]
		}
	];

	if (document.getElementById('contacts-map').classList.contains('mod--contacts-ru')) {
		coordinates = coordinate.ru;
	}

	if (document.getElementById('contacts-map').classList.contains('mod--contacts-en')) {
		coordinates = coordinate.en;
	}

	const xs = window.innerWidth <= 768;
	const map = new google.maps.Map(document.getElementById('contacts-map'), { // eslint-disable-line
		zoom: 17,
		mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'tehgrayz'] // eslint-disable-line
		},
		center: coordinates,
		disableDefaultUI: true,
		scaleControl: false,
		scrollwheel: false,
		zoomControl: false,
		offset: '0%',
		draggable: !xs
	});

	const mapType = new google.maps.StyledMapType(stylez, {name: 'Grayscale'}); // eslint-disable-line
	map.mapTypes.set('tehgrayz', mapType);
	map.setMapTypeId('tehgrayz');
	/* eslint-disable */
	new google.maps.Marker({
		position: coordinates,
		map,
		icon: {
			url: "images/markers/placeholder_b_c.svg",
			scaledSize: new google.maps.Size(50, 65)
		}
	});
	/* eslint-enable */
	if (xs) {
		bindEvents(map);
	}
};

const setScript = () => {
	const script = document.createElement('script');

	script.setAttribute('src', src);

	document.head.appendChild(script);
};

const render = () => {
	if (isElement('.js-contacts')) {
		window.initMap = init;
		setScript();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/contacts/contacts.js